import React from "react";
import { SvgIcon } from "@mui/material";

const MinusIcon = () => {
  const styles = {
    icon: {
      height: 18,
      width: 18
    }
  };

  return (
    <SvgIcon style={styles.icon}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 9H14" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};
export default MinusIcon;